function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_13",
  "data-name": "Group 13",
  transform: "translate(0)"
}, React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12"
}, React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7"
}, React.createElement("g", {
  id: "Group_6",
  "data-name": "Group 6"
}, React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M996.185,47.993h-7.944a6.621,6.621,0,0,0-6.621,6.621v7.944a6.622,6.622,0,0,0,6.621,6.62h7.944a6.62,6.62,0,0,0,6.621-6.62V54.614A6.621,6.621,0,0,0,996.185,47.993Zm4.635,14.561a4.641,4.641,0,0,1-4.635,4.634h-7.944a4.64,4.64,0,0,1-4.634-4.634V54.61a4.639,4.639,0,0,1,4.634-4.634h7.944a4.639,4.639,0,0,1,4.635,4.634Z",
  transform: "translate(-981.62 -47.993)",
  fill: "#3352cb"
}))), React.createElement("g", {
  id: "Group_9",
  "data-name": "Group 9",
  transform: "translate(5.292 5.296)"
}, React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8"
}, React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M992.186,53.267a5.3,5.3,0,1,0,5.3,5.3h0A5.3,5.3,0,0,0,992.186,53.267Zm0,8.606a3.314,3.314,0,1,1,3.314-3.314h0A3.314,3.314,0,0,1,992.186,61.873Z",
  transform: "translate(-986.89 -53.267)",
  fill: "#3352cb"
}))), React.createElement("g", {
  id: "Group_11",
  "data-name": "Group 11",
  transform: "translate(15.581 4.193)"
}, React.createElement("g", {
  id: "Group_10",
  "data-name": "Group 10"
}, React.createElement("circle", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  cx: 0.706,
  cy: 0.706,
  r: 0.706,
  fill: "#3352cb"
})))));

var SvgInstagramIcon = function SvgInstagramIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21.186,
    height: 21.185,
    viewBox: "0 0 21.186 21.185",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInstagramIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram-icon.fa970dc2.svg";
export { ForwardRef as ReactComponent };